import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { replace } from 'connected-react-router';
import _ from 'lodash';

import { Tab, Tabs } from '../../../components/Tabs';
import DeviceCatalog from './DeviceCatalog';
import DeviceMappings from './DeviceMappings';

export const DevicesConfigTabs = {
  catalog: {
    name: 'Device Catalog',
    key: 'deviceCatalog',
  },
  deviceMappings: {
    name: 'Device Mappings',
    key: 'deviceMappings',
  }
};

function DevicesConfig(props) {
  const { replacePath } = props;

  const urlParams = new URLSearchParams(window.location.search);
  const tabFromUrl = urlParams.get('tab');

  const [tab, setTab] = React.useState(tabFromUrl || Object.values(DevicesConfigTabs)[0].key);

  React.useEffect(() => {
    if (tab) {
      const newUrlParams = new URLSearchParams(window.location.search);
      newUrlParams.set('tab', tab);
      replacePath(`${window.location.pathname}?${newUrlParams}`);
    }
  }, [tab, replacePath]);

  const tabArray = React.useMemo(() => {
    return Object.values(DevicesConfigTabs).map(t => (
      <Tab
        label={t.name}
        key={t.key}
      >
        {t.key === DevicesConfigTabs.catalog.key && <DeviceCatalog />}
        {t.key === DevicesConfigTabs.deviceMappings.key && <DeviceMappings />}
      </Tab>
    ));
  }, []);

  return (
    <Tabs
      defaultIndex={tabArray.findIndex(t => t.key === tab)}
      onChange={i => setTab(tabArray[i].key)}
    >
      {tabArray}
    </Tabs>
  );
}

const mapDispatchToProps = dispatch => ({
   replacePath: url => dispatch(replace(url)),
 });
 
 export default connect(null, mapDispatchToProps)(DevicesConfig);
 